module.exports = __webpack_public_path__ + "img/food_truck.2a12ca4e.jpg";